import moment from "moment";
import "moment/locale/de";

import { DEFAULT_LOCALE } from "../constants";

moment.locale(DEFAULT_LOCALE);
